import React, { useEffect, useState } from 'react'

import {
  AuthPageContainer,
  LanguageSelectWrapper,
  LogoContainer,
} from 'Features/auth/common/AuthTemplate/AuthTemplate.styled'
import { CQEssentialsLogo } from 'Assets/icons/CQEssentialsLogo'
import { GeneralSelect } from '@clickcease/cc-client-components-lib'
import { SelectOption } from 'Types/SelectOption'
import { faGlobe } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { LANGUAGES_OPTIONS, LanguagesTypes } from 'Types/Languages'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useSearchParams } from 'react-router-dom'
import { useSetLanguage } from 'Hooks/useSetLanguage'
import languages from 'Assets/lists/languages'

type AuthTemplateProps = {
  children: React.ReactNode
  onLanguageChange?: (language: LanguagesTypes) => void
}

export const AuthPageWrapper = ({ children, onLanguageChange }: AuthTemplateProps) => {
  const { language } = useUserStore()
  const { setLanguage: setUserLanguage } = useSetLanguage()
  const [showLanguageSelector, setShowLanguageSelector] = useState<boolean>(false)
  const [queryParameters] = useSearchParams()

  const setLanguage = async (language: LanguagesTypes) => {
    if (language) {
      await setUserLanguage(language)
      if (onLanguageChange) {
        onLanguageChange(language)
      }
    }
  }

  useEffect(() => {
    setShowLanguageSelector(queryParameters.get('showSelector') === 'true')
    setLanguage((queryParameters.get('lang') as LanguagesTypes) || LANGUAGES_OPTIONS.EN)
      .then(() => {})
      .catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParameters])

  return (
    <AuthPageContainer>
      <LogoContainer>
        <CQEssentialsLogo width={'130px'} />
      </LogoContainer>
      <LanguageSelectWrapper>
        {showLanguageSelector && (
          <>
            <FontAwesomeIcon icon={faGlobe as IconProp} size={'lg'} style={{ margin: '4px' }} />
            <GeneralSelect
              value={languages.find((item) => item.value === language)}
              wrapperCSS={{
                marginLeft: '5px',
                width: '100px',
                '> div:nth-child(1) > div': {
                  minWidth: '120px',
                },
              }}
              options={languages}
              onChange={async (item: SelectOption) => {
                await setLanguage((item?.value as LanguagesTypes) || LANGUAGES_OPTIONS.EN)
              }}
            />
          </>
        )}
      </LanguageSelectWrapper>
      {children}
    </AuthPageContainer>
  )
}
